<template>
  <div id="app">
    <router-view/>
  </div>
</template>
<script>

export default {
  mounted () {
    const userAgentInfo = window.navigator.userAgent
    // eslint-disable-next-line no-array-constructor
    const Agents = new Array('Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod')
    // pc
    if (!Agents.some(item => userAgentInfo.toLowerCase().includes(item.toLowerCase())) && !(self.frameElement && self.frameElement.tagName === 'IFRAME')) {
      const ifrTag = document.getElementsByTagName('iframe')[0]
      if (ifrTag) {
        ifrTag.remove()
      } else {
        const ifrTag = document.createElement('iframe')
        document.body.innerHTML = ''
        ifrTag.setAttribute('src', window.location.href)
        const styleObj = {
          width: '375px',
          height: '1402px',
          position: 'absolute',
          border: 'none',
          left: '50%',
          transform: 'translateX(-50%)'
        }
        Object.entries(styleObj).forEach(([key, value]) => {
          ifrTag.style[key] = value
        })
        document.body.append(ifrTag)
      }
    }
  }
}
</script>

<style lang="less">
#app {
  font-family: "Medium",sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;

  width: 100%;
  height: 100%;
  overflow: hidden;
  font-size: 1rem;
}
div, p, span, h1, h2, h3, h4, h5, button{
  margin: 0rem;
  padding: 0rem;
  box-sizing: border-box;
}
body {
  margin: 0rem;
  padding:0rem;

}

</style>
